<template>
  <main class="app-wrapper">
    <section class="app-main">
      <transition name="fade-transform" mode="out-in">
        <router-view :key="$route.fullPath" />
      </transition>
    </section>
  </main>
</template>

<script>
export default {
  name: "AppMain",
};
</script>

<style lang="scss" scoped>
.app-main {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  position: relative;
  overflow-y: auto;
  background-color: #fff;
}

@media (max-width: 600px) {
  .app-main {
    padding: 1rem;
    min-width: calc(100% - 2rem);
    width: 1200px;
    min-height: 2200px;
  }
}
</style>
